import React from 'react';
import { Flex, Box, Text } from 'rebass/styled-components';
import Collapse from '../components/Collapse';
import { StaticQuery, graphql } from 'gatsby';

const FAQ = () => (
  <StaticQuery
    query={graphql`
      query faqEntryQuery {
        contentfulStudyFaqSection {
          faqEntry {
            id
            answer {
              answer
            }
            question
          }
        }
      }
    `}
    render={data => {
      const { faqEntry } = data.contentfulStudyFaqSection;
      return (
        <Flex flexDirection="column" mx={[4, 5]} py={5}>
          <Box>
            <Text fontSize={'28px'} fontWeight="600" lineHeight={'36px'} mb={3}>
              Frequently asked questions
            </Text>
          </Box>
          <Flex flexDirection="column">
            {faqEntry.map(entry => (
              <Collapse
                question={entry.answer && entry.question}
                answer={entry.answer && entry.answer.answer}
                key={entry.id}
              />
            ))}
          </Flex>
        </Flex>
      );
    }}
  />
);

export default FAQ;
